<template>
  <base-card title="Pilih Daftar Faktur Penjualan Yang Akan Dilaporkan">
    <datatable
      :columns="[
        { id: 'check', name: '' },
        { id: 'No Faktur', name: 'No Faktur' },
        { id: 'Kode Stockist', name: 'Kode Stockist' },
        { id: 'Tanggal', name: 'Tanggal' },
        { id: 'Wilayah Harga', name: 'Wilayah Harga' },
        ...(officeType === 'stockist_center'
          ? [
              { id: 'Belanja', name: 'Belanja' },
              { id: 'Laporan', name: 'Laporan' },
              { id: 'Selisih', name: 'Selisih' },
            ]
          : [{ id: 'Laporan', name: 'Laporan' }]),
      ]"
      :total="orders.meta.page.total"
      :perPage="orders.meta.page.perPage"
      :currentPage="orders.meta.page.currentPage"
      @pagechanged="onChangePage"
    >
      <template #tbody="{ classes }">
        <tr v-for="order in orders.data" :key="order.id" :class="classes.tr">
          <td :class="classes.td">
            <base-checkbox
              :input-value="{
                id: order.relationships.order.data.id,
                reportPrice: getSingleIncluded(
                  orders,
                  order.relationships.order.data.id
                ).attributes[
                  officeType === 'stockist_center'
                    ? 'grand_total_report_price'
                    : 'total_kp_paid'
                ],
              }"
              v-model="checked"
            />
          </td>
          <td :class="classes.td">
            <p class="font-bold text-gray-700">
              {{ order.attributes.origin_code }}
            </p>
          </td>
          <td :class="classes.td">
            {{
              getSingleIncluded(orders, order.relationships.order.data.id)
                .attributes.destination_office_code
            }}
          </td>
          <td :class="classes.td">
            {{ order.attributes.createdAt | formatDate }}
          </td>
          <td :class="classes.td">
            {{
              getSingleIncluded(orders, order.relationships.area.data.id)
                .attributes.name
            }}
          </td>
          <template v-if="officeType === 'stockist_center'">
            <td :class="classes.td">
              {{
                getSingleIncluded(orders, order.relationships.order.data.id)
                  .attributes.grand_total_price | toCurrency
              }}
            </td>
            <td :class="classes.td">
              {{
                getSingleIncluded(orders, order.relationships.order.data.id)
                  .attributes.grand_total_report_price | toCurrency
              }}
            </td>
            <td :class="classes.td">
              {{ calculatePriceGap(order) | toCurrency }}
            </td>
          </template>
          <td :class="classes.td" v-else>
            {{
              +getSingleIncluded(orders, order.relationships.order.data.id)
                .attributes.total_kp_paid | toCurrency
            }}
          </td>
        </tr>
      </template>

      <template #tfoot="{ classes }">
        <tr :class="[classes.tr, 'bg-gray-50']">
          <td :class="classes.td" colspan="5">Total</td>
          <template v-if="officeType === 'stockist_center'">
            <td :class="classes.td">
              {{ orders.meta.total_price | toCurrency }}
            </td>
            <td :class="classes.td">
              {{ orders.meta.total_report_price | toCurrency }}
            </td>
            <td :class="classes.td">
              {{ orders.meta.price_gap | toCurrency }}
            </td>
          </template>
          <td :class="classes.td" v-else>
            {{ orders.meta.total_kp_paid | toCurrency }}
          </td>
        </tr>
      </template>
    </datatable>

    <loading v-if="loading" />
  </base-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { requestMixin } from '../../mixins/request/request';
import BaseCheckbox from '../base/BaseCheckbox.vue';

export default {
  mixins: [requestMixin],
  components: {
    BaseCheckbox,
  },
  props: {
    value: Array,
    officeType: {
      type: String,
      default: 'stockist_center',
    },
  },
  emits: ['input'],
  data() {
    return {
      loading: true,
      orders: {
        data: [],
        meta: {
          page: {},
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      me: 'auth/getUser',
    }),
    checked: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    calculatePriceGap(order) {
      return Math.abs(
        this.getSingleIncluded(this.orders, order.relationships.order.data.id)
          .attributes.grand_total_price -
          this.getSingleIncluded(this.orders, order.relationships.order.data.id)
            .attributes.grand_total_report_price
      );
    },
    async loadOrders(params) {
      this.loading = true;

      const [res, err] = await this.request(`/api/v1/orders`, {
        params: {
          'filter[origin_warehouse_id]': this.me.current_warehouse,
          'filter[order_status]': 'Dikirim,Susulan Dikirim,Selesai',
          'filter[has_bundle]': false,
          'filter[with_summary]': true,
          include: 'order,area',
          'fields[simple-orders]': 'origin_code,order,createdAt,area',
          'fields[orders]': `destination_office_code${
            this.officeType === 'kantor_pelayanan'
              ? ',total_kp_paid'
              : ',grand_total_price,grand_total_report_price'
          }`,
          'fields[areas]': 'name',
          'page[size]': 5,
          ...(this.officeType === 'kantor_pelayanan'
            ? { 'filter[has_kp_paid]': true }
            : {}),
          ...(this.officeType === 'kantor_pelayanan' ? { 'filter[origin_office_id]': this.me.office_id } : {}),
          ...params,
        },
      });

      if (!err) {
        this.orders = res;
      }

      this.loading = false;
    },
    onChangePage(page) {
      this.loadOrders({
        'page[number]': page,
      });
    },
  },
  created() {
    this.loadOrders();
  },
};
</script>
